import {
	AutopayFrequencyOption,
	Ach,
	Card,
	PaymentMethodType
} from './';
import { FeeCalculationType } from '../feeCalculationType';
import { FeeCalculationValue } from '../feeCalculationValue';

export class Autopay {
	key?: number;
	customerAccountKey?: number;
	maxPaymentAmount?: number;
	payInFull?: boolean;
	frequency?: AutopayFrequencyOption;
	dayOfMonth?: number;
	startDate?: Date;
	endDate?: Date;
	numberOfPayments?: number;
	paymentMethod?: Ach | Card;
	overriddenFeeAmount?: number;
	feeCalculationType: FeeCalculationType;
	feeValue?: number;
	feeValues: FeeCalculationValue[];
}

export class AutopayResponse {
	autopayKey?: number;
	customerAccountKey?: number;
	maxPaymentAmount?: number;
	expirationType?: number;
	willPayInFull?: boolean;
	trigger?: AutopayFrequencyOption;
	startDate?: string;
	dayOfMonth?: number;
	endDate?: string;
	numberOfPayments?: number;
	paymentMethod?: Ach | Card;
	overriddenFeeAmount?: number;
	feeCalculationType: FeeCalculationType;
	feeValue?: number;
	feeValues: FeeCalculationValue[];
}
